//Importaciones
import React from 'react'
import { useContext } from 'react';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import MainAppContext from '../../../../MainAppContext';
import { useSelector } from 'react-redux';
import AuthVerify from '../../../../components/Templates/Site/AuthVerify';
import CalendarFilter from '../../../../components/Products/sKPI/Board/CalendarFilter';
import { Responsive, WidthProvider } from 'react-grid-layout';
import { useGetBoardStructureComponentsData2, useGetBoardStructureGeneric } from '../useOfBoard';
import BoardComponentInfoContent from '../ComponentManager/BoardComponentInfoContent';
import { enum__BOARD_TEMPLATE_TYPE } from '../../../../common/Dictionaries';
import { __onGetDataGridHtmlContainer } from '../../../../common/CommonFuctions';
import Loading from '../../../../components/Templates/Site/Loading';
import { __OBJECT_STRUCTURE_BoardFilters } from '../../../../common/ObjectStructures/sKPI';
import { isNullUndefined } from '../../../../common/Helpers';
import CONSOLIDATE_GROUP_CONTRACT_FILTER_TO_COMPARE from '../../../../components/Products/sKPI/Board/_ComponentTypes/CONSOLIDATE_GROUP_CONTRACT_FILTER_TO_COMPARE';

//ESTA PANTALLA ESTABA PENSADA PARA TCH COMO EL COMPARADOR DE CONTRATOS, PERO SE DECIDIÓ QUE USARA EL TEMPLATE PORTFOLIO, POR ENDE ESTA NO SE USA.
//ES POR ELLO QUE EN LA BASE DE DATOS NO ESTÁ EL TEMPLATE.
function ContractCompare(props) {
    //Helpers
    const { token: currentAuth } = useSelector((state) => state.auth);
    const contextSite = useContext(MainAppContext);

    const { _boardComponentInfoRecursiveFilled: boardComponentInfoRecursiveFilled } = useSelector((state) => state.boardViewComponentsScope);

    const ResponsiveGridLayout = WidthProvider(Responsive);
    const BoardTypeId = enum__BOARD_TEMPLATE_TYPE.PORTFOLIO;
    const hasPageElementId = true;

    const queryStringElementId = props.match.params.elementId !== null && props.match.params.elementId !== undefined && props.match.params.elementId !== "" ? props.match.params.elementId : null;

    const { _boardComponentInfoRecursiveValues: boardComponentInfoRecursiveValues } = useSelector((state) => state.boardViewComponentsScope);
    const { _boardPageRedy: boardPageRedy } = useSelector((state) => state.boardViewComponentsScope);
    
    const [boardStructureGeneric, setBoardStructureGeneric] = useState(null)

    const layoutConfiguration = {
        measureBeforeMount: true,
        breakpoints: { lg: 1200, md: 996, sm: 768, xs: 480, xxs: 0 },
        cols: { lg: 36, md: 30, sm: 18, xs: 12, xxs: 6 },
        rowHeight: 46,
        draggableHandle: ".dragHandle",
        margin: [10, 10, 10, 10]
    }

    useGetBoardStructureGeneric(BoardTypeId, queryStringElementId, boardStructureGeneric, setBoardStructureGeneric);
    useGetBoardStructureComponentsData2(__OBJECT_STRUCTURE_BoardFilters("element"), hasPageElementId, queryStringElementId, boardStructureGeneric, contextSite.kpiModule.boardCalendarFilterConfig, boardComponentInfoRecursiveFilled, false);

    const generateContainer = (boardStructure, container) => {
        return  <>
                    {
                        container.l_components_info.map((componentInfo, index) => {
                            return  <div key={index} className='h-100'
                            data-container-id={!isNullUndefined(componentInfo) ? componentInfo.containerId : ''}
                            data-component-id={!isNullUndefined(componentInfo) ? componentInfo.id : ''}>
                                        <BoardComponentInfoContent
                                            inputParam_HasPageElementId={hasPageElementId}
                                            inputParam_ElementId={queryStringElementId}
                                            inputParam_ContainerComponent={componentInfo}
                                            inputParam_BoardType={BoardTypeId}
                                            inputParam_BoardId={!isNullUndefined(boardStructureGeneric.boardId) ? boardStructureGeneric.boardId : boardStructureGeneric[0].id}
                                            inputParam_BoardStructure={boardStructure}
                                            inputParam_Container={container}
                                            inputParam_Index={index}
                                        />
                                    </div>
                                    
                        })
                    }
                </>
            
    };

    //Render de componente.
    return (<>
                <AuthVerify currentToken={currentAuth} />
                {
                    boardPageRedy &&
                    <>
                        <>
                            {
                                boardStructureGeneric &&
                                <CalendarFilter inputParam_BoardId={boardStructureGeneric.boardId} inputParam_ForceShowCalendar={true} />
                            }
                            {
                                boardStructureGeneric && boardComponentInfoRecursiveValues &&
                                boardStructureGeneric.map((boardStructure, indexBoardStructure) => {
                                    return <div key={indexBoardStructure}>
                                        <CONSOLIDATE_GROUP_CONTRACT_FILTER_TO_COMPARE
                                            inputParam_UseFake ={false}
                                            inputParam_HideHeader={false}
                                            inputParam_ComponentContent={null}
                                            inputParam_BoardId={!isNullUndefined(boardStructureGeneric.boardId) ? boardStructureGeneric.boardId : boardStructureGeneric[0].id}
                                        />
                                        {
                                            boardStructure.l_structure.length === 1 &&
                                            <ResponsiveGridLayout
                                                measureBeforeMount={layoutConfiguration.measureBeforeMount}
                                                breakpoints={layoutConfiguration.breakpoints}
                                                cols={layoutConfiguration.cols}
                                                rowHeight={layoutConfiguration.rowHeight}
                                                isDraggable={false}
                                                isDroppable={false}
                                                isResizable={false}
                                                //onLayoutChange={onLayoutChange}
                                                //onResize={onResize}
                                                //draggableHandle={ boardMoveZones ? ".dragHandle" : '.no-drag'}
                                                margin={[10, 10, 10, 10]}
                                            >
                                                {
                                                    boardStructure.l_structure[0].l_container.map((container, index) => (
                                                        <div key={index} data-grid={ __onGetDataGridHtmlContainer(container) }  className="gridItem" style={{ height: `${container.h * 50}px`, width: `${container.w * 48.5}px` }}>
                                                            {generateContainer(boardStructure, container)}
                                                        </div>
                                                    ))
                                                }
                                            </ResponsiveGridLayout>
                                        }
                                        {
                                            boardStructure.l_structure.length > 1 &&
                                            boardStructure.l_structure.map((structure, index) => {
                                                return <ResponsiveGridLayout
                                                    key={index}
                                                    breakpoints={{ lg: 1200, xs: 480 }}
                                                    cols={ { lg: 12, xs: 6 } }
                                                    rowHeight={ structure.htmlStructure.rowHeight }
                                                    //onLayoutChange={onLayoutChange}
                                                    //onResize={onResize}
                                                    //draggableHandle={ boardMoveZones ? ".dragHandle" : '.no-drag'}
                                                    margin={[10, 10, 10, 10]}
                                                >
                                                    {
                                                        structure.l_container.map((container, index) => (
                                                            <div key={index} className="gridItem" style={{ height: `${container.h * 50}px`, width: `${container.w * 48.5}px` }}>
                                                                {generateContainer(container)}
                                                            </div>
                                                        ))
                                                    }
                                                </ResponsiveGridLayout>
                                            })
                                        }
                                    </div>
                                }) 
                            }
                        </>
                        <>
                            {
                                //(queryStringBoardId === null || (userPropsKpi.hasAccess === false && userPropsKpi.onlyObserver === false)) &&
                                //<div className="pt-5 mt-4">
                                //    <MessageBox  
                                //        inputParam_Message={ queryStringBoardId === null ? t('data-lang-msg-invalidboard') : ((userPropsKpi.hasAccess === false && userPropsKpi.onlyObserver === false) ? t('data-lang-msg-accessdenied') : "") }
                                //        inputParam_Display={ messageConfig.showMessage }
                                //        inputParam_MessageType={ messageConfig.messageType }
                                //        inputParam_SetterMessage={ setMessageConfig }
                                //    />
                                //</div>
                            } 
                        </>
                    </>
                }
                {
                    !boardPageRedy &&
                    <div>
                        <Loading inputParam_ShowLoading={true}/>
                    </div>
                }   
            </>
    );
}

export default ContractCompare;